<template>
  <div id="T0a">
    <div class="wrapper">
      <a id="btn_search-box" @click="btnSearchBoxClick()"></a>
      <kg-header @openSearchBoxEvent="openSearchBox()"/>
      <kg-category-list
        :swipeList="swipeCategoryList"
        :swiperOptions="CategoryListOptions"
        :horizontalMode="false"
        ref="ddCategoryList"
      />
      <kg-search
        :categoryList="categoryList"
        :styleList="styleList"
        :shapes="searchShapeList"
        @setSlideEvent="setSlide($event)"
        @setOpenPlanListEvent="setOpenPlanList($event)"
        ref="ddSearch"
      />
      <!-- <div v-if="openPlanList.length > 0" id="content"> -->
      <div v-if="openPlanList" id="content">
        <div id="search_result">
          <div class="inner_static">
            <p class="lead">プラン検索結果 <strong class="num">{{this.openPlanList.length}}</strong>件</p>
            <p class="keyword">Keyword: <span>{{this.keyword}}</span></p>
          </div>
        </div>
        <div id="post">
          <div class="inner_static">
            <ul class="lst_post">
              <li v-for="(plan, index) in this.openPlanList" :key="index"
                  v-bind:class="{hide_element: dispPlanCount <= index}">
                <a>
                  <span class="image" @click="planClick(plan)">
                    <!-- TODO noimageでサイズが変わるので対応 -->
                    <img :src="getImage(plan.kgFdImage)" @error="noImage" alt="">
                  </span>
                  <ul class="postinfo">
                    <li class="like">25</li>
                    <li class="price">5</li>
                    <li class="username">User Name</li>
                  </ul>
                </a>
              </li>
            </ul>
            <div class="btn_area" v-if="openPlanList.length > dispPlanCount">
              <a class="btn_more1" @click="btnMoreClick()">More</a>
            </div>
          </div>
        </div>
      </div>
      <kg-news-list :upperLimit=3 />
      <div class="btn_area">
        <a class="btn_more2" @click="btnNewsMoreClick()">More</a>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <kg-loading-modal ref="loadingModalRef" />
  </div>
</template>

<script>
import axios from 'axios'

import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import {KG_URL} from '../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'

// kaggul Module
import Header from '../components/common/Header'
import CategoryList from '../components/top/CategoryList'
import Search from '../components/top/Search'
import NewsList from '../components/top/NewsList'

export default {
  name: 'Top',
  components: {
    'kg-header': Header,
    'kg-category-list': CategoryList,
    'kg-search': Search,
    'kg-loading-modal': LoadingModal,
    'kg-news-list': NewsList
  },
  data () {
    return {
      categoryList: [],
      CategoryListOptions: {
        slidesPerView: 'auto',
        slidesPerColumn: 1,
        loop: true,
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true
        // },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        // touchEventsTarget: 'wrapper',
        SimulateTouch: true,
        touchStartPreventDefault: false,
        preventClicks: true,
        centeredSlides: true,
        spaceBetween: 0,
        initialSlide: 0,
        on: {
          slideChangeTransitionEnd: () => {
            // トップ画面のカテゴリスライドのスライド終了時に実行される
            // 新たに選択されたカテゴリーIDを検索コンポーネントに設定
            this.$refs.ddSearch.setSelectedCategoryId(this.categoryList[this.activeIndex].categoryId)
            // 自身の持つ現在のカテゴリーIDを更新してコンポーネントの検索処理呼び出し
            this.currentCategoryId = this.categoryList[this.activeIndex].categoryId
            this.$refs.ddSearch.search()
          }
        }
      },
      styleList: [],
      openPlanList: null,
      dispPlanCount: 6,
      keywordText: '',
      currentCategoryId: 1
    }
  },
  methods: {
    init: function (id, param) {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        params: {
          category: id
        }
      }
      axios.get(KG_URL.TOP + '/init', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            let data = response.data.data
            this.categoryList = data.categoryList
            this.styleList = data.styleList
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    planClick: function (plan) {
      // TODO 公開プラン選択時の処理
      console.log(plan.kgFdId)
      console.log(plan.kgFdName)
    },
    btnMoreClick: function () {
      this.dispPlanCount += 3
    },
    setOpenPlanList: function (result) {
      this.openPlanList = result.list
      // 表示件数初期化
      this.dispPlanCount = 6
      // 表示用キーワード文字列設定
      this.keywordText = result.keyword
    },
    btnSearchBoxClick: function (event) {
      // 検索ボックスを表示する
      if (event) {
        event.preventDefault()
      }
      var scrollpos = 0
      var searchBox = document.getElementById('search-box')
      var bodyElements = document.getElementsByTagName('body')
      if (searchBox.classList.contains('open')) {
        searchBox.classList.remove('open')
        bodyElements[0].classList.remove('fixed')
        bodyElements[0].style.top = 0
        window.scrollTo(0, scrollpos)
      } else {
        searchBox.classList.add('open')
        scrollpos = window.scrollTop
        bodyElements[0].classList.add('fixed')
        bodyElements[0].style.top = -scrollpos
      }
    },
    openSearchBox: function () {
      this.btnSearchBoxClick(null)
    },
    btnNewsMoreClick: function () {
      // ニュース一覧画面へ遷移
      this.$router.push('/kagull/news')
    },
    getSlideIndexFromCategoryId (categoryId) {
      // 引数のカテゴリーIDを持つ要素のインデックスを返す
      if (this.categoryList) {
        for (let i = 0; i < this.categoryList.length; i++) {
          if (this.categoryList[i].categoryId === categoryId) {
            return i
          }
        }
      }
      return 0
    },
    setSlide (categoryId) {
      if (this.currentCategoryId === categoryId) {
        // 現在と同じカテゴリIDであった場合は検索処理のみ
        this.$refs.ddSearch.search()
      } else {
        // 新たなインデックスにスライドを移動させてイベント実行
        let index = this.getSlideIndexFromCategoryId(categoryId)
        this.$refs.ddCategoryList.setSlideTo(index)
      }
    },
    handleErrorMessage: function (response) {
      if (!response || !response.data) {
        return
      }
      let modalData = {
        title: 'エラー',
        messages: response.data.errorMessage.split(/\r?\n/g),
        messageType: 'error',
        textAlign: 'left'
      }
      App.showModal(modalData)
    },
    getImage: function (image) {
      return App.getContentsResource(image)
    },
    noImage: function (element) {
      element.target.src = App.getKagullResource('noimage.svg')
    }
  },
  computed: {
    swipeCategoryList: function () {
      return this.categoryList.map(e => {
        return {
          id: e.categoryId,
          name: e.categoryName,
          caption: e.categoryCaption,
          img: e.categoryImage
        }
      })
    },
    // TODO シェイプ実装次第削除
    searchShapeList: function () {
      return this.categoryList.map(e => {
        return {
          id: e.categoryId,
          name: e.categoryName,
          img: e.categoryIcon
        }
      })
    },
    activeIndex () {
      // カテゴリーの配列の添え字の値に変換して返す
      let temp = this.$refs.ddCategoryList.swiperActiveIndex
      if (!this.categoryList || this.categoryList.length === 0) {
        return 0
      }
      return temp % this.categoryList.length
    },
    keyword () {
      if (!this.keywordText || !this.keywordText.trim()) {
        return 'なし'
      }
      return this.keywordText
    }
  },
  mounted: function () {
    // TODO: 引数は仮の値,やがて修正
    this.init(1, 1)
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>
<style lang="scss" >
body {
    overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/KgTop.vue